import RoomLayout from "/components/shared/layouts/RoomLayout.jsx";
import RoomBox from "/components/shared/layouts/RoomBox.jsx";
import ViewHeader from "/components/shared/ViewHeader.jsx";
import SubViewHeader from "/components/shared/SubViewHeader";
import {useContext, useEffect, useState} from "react";
import AppContext from "/context/AppContext";
import {fetchProductions} from '/api/productions';
import {filterProductions, flattenProductionsToShows} from '/utils';
import FilterEventContext from "/context/filter/FilterContext";
import Head from "next/head";
import {filter, chunk} from 'lodash';
import ShowsContainer from "/components/modules/schedule/ShowsContainer";
import {useRouter} from "next/router";
import {SvgLeftArrow, SvgRightArrow} from "/components/shared/SvgIcons";
import {DateTime} from "luxon";
import {motion} from "framer-motion";

export default function Schedule({year, month}) {
    const {productions} = useContext(AppContext);
    const [filteredProductions, setFilteredProductions] = useState(productions);
    const {state: {searchQuery}} = useContext(FilterEventContext);
    const router = useRouter();
    useEffect(() => {
        setFilteredProductions(filterProductions(productions, searchQuery));
    }, [searchQuery]);

    const handlePreviousClick = () => {
        let newMonth = month - 1;
        let newYear = year;
        if (newMonth === 0) {
            newMonth = 12;
            newYear -= 1;
        }
        router.push(`/schedule/${newYear}/${newMonth}`)
    }
    const handleNextClick = () => {
        let newMonth = month + 1;
        let newYear = year;
        if (newMonth === 13) {
            newMonth = 1;
            newYear += 1;
        }
        router.push(`/schedule/${newYear}/${newMonth}`)
    }
    const shows = filter(flattenProductionsToShows(filteredProductions), show => {
        const startDate = DateTime.fromISO(show.start_date);
        return startDate.month == month && startDate.year === year;
    });

    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
        <motion.div
        initial={{opacity: 0, translateY: 500}}
        animate={{opacity: 1, translateY: 0}}
        exit={{opacity: 0, scale: 0.5}}
        className={`relative flex flex-col overflow-mx-4 mt-24 md:w-[50vw] h-[80vh] bg-white rounded-[16px]`}>
            <div
              className="bg-light_brown md:px-3 2xl:pl-12 py-2 md:py-3 2xl:py-8 rounded-t-[16px]">
              <ViewHeader title="zum foyer" url="/foyer"/>
              <SubViewHeader
                url="/productions"
                label="Spielplan"
                buttonLabel="Alle Stücke"
              />
            </div>
            <div
              className="flex justify-center items-center mt-2 sm:mt-4 cursor-pointer pb-2 border-b border-black-rgba-bg">

              <div onClick={handlePreviousClick}>{SvgLeftArrow("#AC8243", "#fff")}</div>
              <h1 className="mx-2 sm:mx-4 text-md xl:text-lg flex justify-around w-32 xl:w-52 select-none">
                <div className='mx-1'>
                  {DateTime.local(year, month, 1).setLocale('de').toFormat('LLLL')}
                </div>
                <div>
                  {year}
                </div>
              </h1>
              <div onClick={handleNextClick}>{SvgRightArrow("#AC8243", "#fff")}</div>
            </div>
            <div
              className='flex-1 text-sm md:text-base xl:text-lg w-fit sm:w-full overflow-y-auto'>
              <ShowsContainer shows={shows}/>
            </div>
        </motion.div>
        </RoomLayout>
    );
}

export async function getStaticPaths(context) {
    const productions = await fetchProductions();
    let paths = [];
    for (let i = 0; i < 4; i++) {
        let year = 2022 + i;
        for (let month = 1; month < 13; month++) {
            paths.push({
                params: {yearmonth: [year.toString(), month.toString()]}
            });
        }
    }

    paths.push({
        params: {yearmonth: []}
    });

    return {
        paths,
        fallback: 'blocking'
    };
}

export async function getStaticProps({params}) {
    let year, month;

    if (!params.yearmonth || params.yearmonth.length < 2) {
        year = DateTime.local().year;
        month = DateTime.local().month;
    } else {
        year = parseInt(params.yearmonth[0]);
        month = parseInt(params.yearmonth[1]);
    }
    const productions = await fetchProductions();
    return {
        props: {
            productions,
            year: year || null,
            month: month || null,
        },
        revalidate: 60
    };
}

